import {
    feedbackDialogThankYouHeader,
    feedbackDialogThankYouMessage,
    feedbackDialogCloseButtonText,
} from './InlineFeedbackDialogThankYou.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import { DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { UserVoiceForumUrlFormat, consumerForumId, enterpriseForumId } from 'owa-uservoice';

let styles = require('./InlineFeedbackDialog.scss');
let thanksBubbleImage = require('../assets/ThankYouImage.svg');

export interface InlineFeedbackDialogThankYouProps {
    onCloseButtonClick: () => void;
}
@observer
export default class InlineFeedbackDialogThankYou extends React.Component<
    InlineFeedbackDialogThankYouProps,
    {}
> {
    private getUVForumLink = (): string => {
        if (isConsumer()) {
            return format(UserVoiceForumUrlFormat, consumerForumId.toString());
        } else {
            return format(UserVoiceForumUrlFormat, enterpriseForumId.toString());
        }
    };

    render() {
        return (
            /* tslint:disable:react-no-dangerous-html */
            <div>
                <div className={styles.thankYouDiv}>
                    <img className={styles.thankYouBubble} src={thanksBubbleImage} />
                </div>
                <div className={styles.thankYouHeader}>{loc(feedbackDialogThankYouHeader)}</div>
                <div className={styles.thankYouMessage}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: format(
                                loc(feedbackDialogThankYouMessage),
                                this.getUVForumLink()
                            ),
                        }}
                    />
                </div>
                <DialogFooter>
                    <DefaultButton
                        className={styles.closeButton}
                        onClick={this.props.onCloseButtonClick}>
                        {loc(feedbackDialogCloseButtonText)}
                    </DefaultButton>
                </DialogFooter>
            </div>
            /* tslint:enable:react-no-dangerous-html */
        );
    }
}
